/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useLayoutEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../../../common/constants';
import createEventPayload from '../../../../common/utils/analytics/analytics.codegen';
export function TrackTabViewed(_ref) {
  var activePlugin = _ref.activePlugin;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useLayoutEffect(function () {
    if (activePlugin) {
      createAnalyticsEvent(createEventPayload('ui.tab.viewed', {})).fire(ANALYTICS_CHANNEL);
    }
  }, [activePlugin, createAnalyticsEvent]);
  return null;
}